import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCustomFieldList(params) {
  return request({
    url: URL.sys.customField,
    method: 'get',
    params
  })
}

export function saveCustomField(data) {
  return request({
    url: URL.sys.customFieldAdd,
    method: 'post',
    data
  })
}

export function updateCustomField(data) {
  return request({
    url: URL.sys.customFieldUpdate,
    method: 'post',
    data
  })
}

export function delCustomField(uuid) {
  return request({
    url: URL.sys.customFieldDelete + '?uuid=' + encodeURIComponent(uuid),
    method: 'post'
  })
}

